import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import SplitterDemo from './SplitterDemo'
import SplitterEditorActions from './SplitterEditorActions'
import SplitterElement from './SplitterElement'
import SplitterFormBrand from './SplitterFormBrand'
import { STYLE_FORM_SCHEMA } from './SplitterFormStyle'
import SplitterFormValue from './SplitterFormValue'
import splitterIcon from './assets/splitter.svg'

export default genElementConfig(CONFIG_ELEMENTS.splitter, {
  label: t('elements.splitter.label'),
  icon: splitterIcon,
  group: ElementGroup.interactive,
  styleFields: STYLE_FORM_SCHEMA,
  Element: SplitterElement,
  Demo: [SplitterDemo],
  FormValue: SplitterFormValue,
  FormBrand: SplitterFormBrand,
  EditorActions: SplitterEditorActions,
})
